import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ClaimDto} from "../../../../../auto-generated-server-dtos/adjuster/list-claims/claim-dto";
import {environment} from "../../../../../../environments/environment";
import {AdjusterDto} from "../../../../../auto-generated-server-dtos/adjuster/claim/assign-to/adjuster-dto";

@Injectable({
  providedIn: 'root'
})
export class GetAdjusterByClaimIdService {
  constructor(private httpClient: HttpClient) {
  }

  getAdjusterByClaimId(claimId: number) {
    return this.httpClient.get<AdjusterDto>(`${environment.apiServer}/Adjuster/Claim/GetAdjusterByClaimId`, {params: {claimId: claimId}});
  }
}
